<template>
  <div id="viewbook">
        <section class="py-5" v-if="loading">
            Loading...
        </section>
        <section class="py-5" v-else-if="notfound">
            Puzzle not found.
        </section>        
        <section class="py-5" v-else>
            <div class="container">
                <div class="row gx-4 gx-lg-5 align-items-center">
                    <div class="row">
                        <div class="col"><span v-if="previous"><a class="text-decoration-none" :href="`/puzzles/${previous}`">&#x2190; {{previous}}</a></span></div>
                        <div class="col"><a class="text-decoration-none" :href="`/puzzles/${date}.pdf`">PDF</a> | <a class="text-decoration-none" :href="`/puzzles/${date}.png`">PNG</a> | <a class="text-decoration-none" href="/howtosolve">How to Solve</a></div>
                        <div class="col"><span v-if="next"><a class="text-decoration-none" :href="`/puzzles/${next}`">{{next}} &#x2192;</a></span></div>
                    </div>
                    
                    <div class="col-md-6 offset-md-3 text-center">
                        <img class="border card-img-top mb-5 mb-md-0" :src="cover" alt="..." />
                        <btn class="btn text-primary" v-if="puzzle" @click="toggleAnswer()">{{showAnswer ? 'Hide' : "Show"}} Solution</btn>
                        <span v-else>Come back tomorrow for the solution...</span>
                        <div class="text-start" v-if="showAnswer">{{puzzle}}</div>
                    </div>
                    
                </div>
            </div>
        </section>
  </div>
</template>

<script>

export default {
  name: 'ViewPuzzle',
  mounted() {
    this.puzzleId = this.$route.params.puzzleId||'latest';
    console.log(this.puzzleId);
    this.fetchPuzzle();
  },
  data() {
    return {
        title: "",
        cover: "",
        date: "",
        previous: "",
        next: "",
        puzzle: "",
        showAnswer: false,
        notfound: false,
        loading: true
    }
  },
  methods: {
    toggleAnswer() {
        this.showAnswer = !this.showAnswer;
    },
    async fetchPuzzle() {
        const response = await fetch("/puzzles/" + this.puzzleId + ".json", { cache: "no-store" });
        console.log(response.status);
        if(response.status == '404') {
            this.notfound = true;
            this.loading = false;
            document.title = "Katie's Puzzles | Not Found";
        } else {

            const json = await response.json();

            this.title = json.title;
            this.cover = '/puzzles/'+json.date+".png";
            this.date = json.date;
            this.previous = json.previous;
            this.next = json.next;
            this.puzzle = json.puzzle;
            this.loading = false;
            document.title = "Katie's Puzzles | "+this.title;
        }
    }
  }
}
</script>

<style>

</style>
